import { AxiosPromise } from 'axios';
import { LoginResponse, RegistrationInput } from 'features/auth/ts';
import { api } from 'api';
import { DefaultSuccessResponse } from 'ts/DefaultSuccessResponse';
import { getCurrentLanguage } from 'utils/getCurrentLanguage';

export const registerUser = (data: RegistrationInput): AxiosPromise<DefaultSuccessResponse> =>
  api.post(`/partners/registration/`, data);

export const registerFieldValidation = ({ fieldName, value }: { fieldName: 'email' | 'company_name'; value: string }) =>
  api.post(`partners/registration/${fieldName}/validate/`, { value });

export const login = (email: string, password: string): AxiosPromise<'ok'> =>
  api.post(`/profiles/login/`, {
    email,
    password,
  });

export const loginByVerificationCode = (token: string): AxiosPromise<LoginResponse> =>
  api.post('/profiles/otp-login/', { token });

export const autologin = (token: string): AxiosPromise<LoginResponse> =>
  api.post(`/profiles/auto-login/`, {
    token,
  });

export const logout = (): AxiosPromise<void> => api.post(`/profiles/logout/`);

export const resetPassword = (email: string): AxiosPromise<DefaultSuccessResponse> => {
  const lang = getCurrentLanguage();
  return api.post(`/profiles/password/reset/`, { email }, { headers: { 'Accept-Language': lang } });
};

export const confirmResetPassword = (token: string, new_password: string): AxiosPromise<DefaultSuccessResponse> =>
  api.post(`/profiles/password/reset/confirm/`, { token, new_password });

export const confirmRegistration = (token: string, new_password: string): AxiosPromise<LoginResponse> =>
  api.post(`/profiles/partner-registration/confirm/`, { token, new_password });

export const uploadVerificationDocuments = (data: FormData): AxiosPromise<DefaultSuccessResponse> =>
  api.post(`/partners/documents/`, data);
